import Vue from 'vue';
import Slick from 'vue-slick';

Vue.component('Slick', Slick);
